import $ from 'jquery';
import i18n from 'i18next';

// Import helpers
import { getHeaders } from 'helpers/headers';

export const SHAKA_PLAYER_ERRORS = {
	BROWSER_NOT_SUPPORTED: i18n.t('player_error_browser_not_supported'),
	SHAKA_PLAYER_ERROR_MESSAGE: i18n.t('player_error_shaka_player_error_message')
};

// Sync request on browser reload
export const playerDeleteSyncRequest = (videoSession) => {
	$(function() {
		if (videoSession) {
			const headers = getHeaders();

			const url = `${process.env.REACT_APP_API_URL}/player/videosession/${videoSession}?platform=BROWSER`;

			$.ajax({
				type: 'DELETE',
				headers,
				url,
				async: false
			});
		}
	});
};

export const AUTO_QUALITY = {
	id: 'auto',
	name: i18n.t('player_settings_quality_auto'),
	value: 'auto',
	height: 'auto'
};

export const SUBTITLES_DISABLE = {
	id: 'disabled',
	name: i18n.t('player_settings_subtitles_disabled'),
	value: ''
};

export const checkIsAbr = (value) => value === AUTO_QUALITY.id;

export const getPlayerSettings = (player) => {
	const variantTracks = player.getVariantTracks();
	const audioLanguages = player.getAudioLanguagesAndRoles();

	const displayNames = new Intl.DisplayNames('pl', {
		type: 'language',
		fallback: 'none'
	});

	return audioLanguages.map(({ language, role }) => {
		const tracks = variantTracks
			.filter(({ language: lang, roles }) => {
				if (lang !== language) return false;
				return role ? roles.includes(role) : !roles.length;
			})
			.map((item) => ({ ...item, value: item.id, name: `${item.height}p` }))
			.sort((a, b) => b.height - a.height);

		const profiles = [AUTO_QUALITY, ...tracks];
		const value = `${language}${role}`;

		const name =
			displayNames.of(language) ?? i18n.t('player_settings_language_undefined');

		return { language, role, name, profiles, value };
	});
};

export const getInitialVideoLanguage = (tracks) =>
	tracks.reduce((acc, { value, profiles }) => {
		const isLangActive = profiles.some(({ active }) => active);
		return isLangActive ? value : acc;
	}, 'pl');

export const getPlayerSubtitles = (player) => {
	const textTracks = player.getTextTracks();

	const subtitlesArray = textTracks
		.filter(({ language }) => language)
		.map((item) => {
			const { language } = item;
			const lng = language.toLowerCase();
			const name = i18n.t(`player_settings_subtitles_${lng}`, lng);
			return { ...item, value: language, name };
		});

	return [SUBTITLES_DISABLE, ...subtitlesArray];
};

export const getPlayerProfiles = ({ tracks, selectedLanguage }) => {
	const langTracks = tracks.find(({ value }) => value === selectedLanguage);
	const profiles = langTracks?.profiles ?? [];
	return profiles.filter((item) => item?.height);
};

export const checkSeekAvailable = (context) => {
	if (!context) return false;
	switch (window.location.hash) {
		case '#catchup':
			return !!context.catch_up_seek;

		case '#npvr':
			return !!context.npvr_seek;

		default:
			return false;
	}
};
